<template>
  <footer
    :class="['footer', getRouteName !== 'index' || getRouteName !== 'errorPage' ? 'footer--page' : 'footer--index']"
    :style="{ pointerEvents: getRouteName === 'index' ? 'none' : 'all' }"
  >
    <div
      class="ui-container"
    >
      <div class="footer__stamp-cont" ref="stampcont">
        <!-- <div class="footer__stamp-anim" ref="lottie">
        </div> -->
        <svg class="footer__stamp" ref="stamp">
          <use :xlink:href="getCity === 'san-francisco' ? '#sf-stamp' : '#ny-stamp'" />
        </svg>
      </div>
      <div class="footer__row">
        <div class="footer__item footer--about">
          <h4>ABOUT US</h4>
          <p>
            Awwwards is the most visited digital design awards platform in the world.
            Every year we hold conferences in iconic cities across the globe including New York, Amsterdam, Paris, London and Los Angeles, to discover trends and new technologies, network and unveil the secrets of the Internet.<br>
            Visit <a class="ui-link" data-hover="awwwards.com" href="https://www.awwwards.com/" rel="noopener" target="_blank">awwwards.com</a>.
          </p>
        </div>
        <div class="footer__item footer--contact">
          <h4>FOLLOW US</h4>
          <ul>
            <li>
              <a class="ui-link" data-hover="Facebook" href="https://www.facebook.com/awwwards/" rel="noopener" target="_blank">Facebook</a>
            </li>
            <li>
              <a class="ui-link" data-hover="Twitter" href="https://twitter.com/awwwards" rel="noopener" target="_blank">Twitter</a>
            </li>
            <li>
              <a class="ui-link" data-hover="Instagram" href="https://www.instagram.com/awwwards/" rel="noopener" target="_blank">Instagram</a>
            </li>
            <li>
              <a class="ui-link" data-hover="YouTube" href="https://www.youtube.com/channel/UCYWGYef22gx8PaXZMLHAQsw" rel="noopener" target="_blank">YouTube</a>
            </li>
          </ul>
        </div>
        <div class="footer__item footer--next-c">
          <h4>CONTACT</h4>
          <ul>
            <li>
              <a class="ui-link" data-hover="Write to us" href="mailto:conference@awwwards.com">Write to us</a>
            </li>
            <li>
              <a class="ui-link" data-hover="Be a sponsor" href="mailto:sarah@awwwards.com">Be a sponsor</a>
            </li>
          </ul>
          <h4 class="footer__sublist"><bdi v-html="dir" /> CONF.</h4>
          <ul>
            <transition @enter="enter" @leave="leave">
              <li v-if="getCity === 'san-francisco'">
                <router-link class="ui-link" data-theme="pink" data-hover="New York" to="/new-york">New York</router-link>
              </li>
              <li v-if="getCity === 'new-york'">
                <a
                  class="ui-link"
                  href="https://www.universe.com/events/digital-thinkers-conference-tokyo-tickets-chiyoda-city-14JHSQ"
                  data-theme="blue" data-hover="Tokyo"
                >Tokyo
                </a>
              </li>
            </transition>
          </ul>
        </div>
      </div>
      <div class="footer__row footer__row--border footer--copyright">
        <div>
          <a class="ui-link" href="https://adoratorio.studio/" rel="noopener" target="_blank" data-hover="Adoratorio Studio">Adoratorio Studio</a> with <a class="ui-link" href="http://www.marianopascual.me/" rel="noopener" target="_blank" data-hover="Mariano Pascual">Mariano Pascual</a>
        </div>
        <div class="footer__row--margin">
          <span class="footer__modal-toggle ui-link-alt" @click="openModal">Code of conduct</span><span class="separator">|</span><a href="/static/pdf/sponsorship-plans.pdf" rel="noopener" target="_blank" class="ui-link-alt">Sponsorship plans</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// import lottie from 'lottie-web';
import { mapGetters } from 'vuex';
import loop from '@/scripts/loop';
// import { lottieAnimation } from '@/scripts/utils';

import stampNy from '@/assets/data/index-ny-animation.json';

export default {
  name: 'footerComp',

  props: {
    openModal: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      postAnimated: false,
      limit: window.innerHeight,
      loopRemoved: true,
      animationStamp: null,

      dir: 'NEXT',
    };
  },

  computed: {
    ...mapGetters(['getRouteName', 'getCity']),
  },

  watch: {
    // getCity(newVal, oldVal) {
    //   if (!this.loopRemoved) {
    //     this.loopRemoved = true;
    //     loop.remove(`set-footer-stamp-${oldVal}`);
    //     this.animationStamp.destroy();
    //     this.$refs.stampcont.removeAttribute('js-animated');
    //   }

    //   this.$refs.stamp.style.opacity = 0;
    //   loop.add(this.checkPosition, `set-footer-stamp-${newVal}`, true);
    //   this.loopRemoved = false;

    //   // if (newVal === 'amsterdam') {
    //   //   this.dir = 'NEXT';
    //   // } else {
    //   //   this.dir = 'PREV';
    //   // }
    //   this.dir = 'NEXT';
    // },
  },

  mounted() {
    // loop.add(this.checkPosition, `set-footer-stamp-${this.getCity}`, true);
    // this.limit = this.$refs.stampcont.getBoundingClientRect().top;
    // this.loopRemoved = false;
  },

  methods: {
    checkPosition() {
      if (this.$refs.stampcont === undefined) return;

      if (this.getRouteName === 'index' && this.getRouteName === 'errorPage') {
        return;
      } else if ((window.lerpedScrollY + (window.innerHeight - 150)) > (this.$refs.stampcont.getBoundingClientRect().top + window.lerpedScrollY) && !this.$refs.stampcont.hasAttribute('js-animated')) {
        this.$refs.stampcont.setAttribute('js-animated', '');

        this.animateStamp().play();
      }
    },

    animateStamp() {
      const data = this.getCity === 'san-francisco' ? stampSf : stampNy;
      const anim = lottieAnimation(this.$refs.lottie, data.init);

      anim.onComplete = () => {
        if (this.loopRemoved) return;
        this.loopRemoved = true;

        this.$refs.stamp.style.opacity = 1;
        anim.destroy();
        loop.remove(`set-footer-stamp-${this.getCity}`);
        this.loopRemoved = true;
        this.$refs.stampcont.removeAttribute('js-animated');
      };

      this.animationStamp = anim;

      return anim;
    },

    enter(el, done) {
      anime({
        targets: el,
        duration: 400,
        opacity: [0, 1],
        complete: done,
      });
    },

    leave(el, done) {
      anime({
        targets: el,
        duration: 400,
        opacity: [0, 1],
        delay: 800,
        complete: done,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  width: 100%;
  padding: 80px 20px 20px;

  @include mq(ipadP) {
    padding: 80px 40px 0;
  }

  @include mq(ipadL) {
    padding: 160px 0 80px;
  }


  &.footer--index {
    position: fixed;
    bottom: 0;
  }

  &--copyright {
    font-size: 0.875rem;

    @include mq($until: mobileL) {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
  }

  &.footer--page {
    background-color: $color-gray;

    .footer__row {
      position: relative;
      width: 100%;

      display: flex;
      align-items: baseline;
      justify-content: flex-start;
      flex-flow: row wrap;

      @include mq($until: mobileL) {
        padding: 0 20px;
      }

      &--margin {
        @include mq($until: mobileL) {
          margin-top: 15px;
        }
      }

      &--border {
        position: relative;
        margin-top: 40px;
        padding: 20px 0 0;

        justify-content: space-between;

        @include mq(ipadP) {
          padding: 20px 0;
        }

        &::before {
          content: '';
          position: absolute;
          top: -1px;
          left: 20px;
          width: calc(100% - 40px);
          height: 1px;

          background-color: rgba(68, 68, 68, 0.7);

          @include mq(ipadP) {
            left: 0;
            width: 100%;
          }
        }

        a {
          @include mq($until: ipadP) {
            margin-top: 10px;
            order: 2;
          }
        }
      }
    }
  }

  &__sublist {
    margin-top: 33px !important;

    @include mq(ipadP) {
      margin-top: 28px !important;
    }
  }

  .footer__item {
    flex: 0 0 auto;

    &.footer--about {
      width: 100%;

      @include mq(ipadP) {
        flex: 2 0 auto;
        width: 50%;
        padding-right: 80px;
      }

      @include mq(ds) {
        margin-right: 120px;
      }

      a {
        font-weight: 700;
      }

      p {
        font-size: 1rem;
      }
    }

    &:not(.footer--about) {
      @include mq($until: ipadP) {
        width: 50%;
        flex: 0 0 50%;

        h4 {
          margin-top: 40px;
        }
      }
    }

    &.footer--contact {
      @include mq(ipadP) {
        margin-right: 60px;
      }

      @include mq(ds) {
        margin-right: 120px;
      }

      ul {
        display: inline-block;
        transform: translateY(-5px);
      }
    }

    &.footer--next-c {
      ul {
        display: inline-block;
        transform: translateY(-5px);
      }
    }

    ul {
      line-height: 2;
    }
  }

  h4 {
    margin-bottom: 20px;
    font-size: font-size(s);

    @include mq(ipadP) {
      margin-bottom: 10px;
    }
  }

  &__stamp-cont {
    position: relative;
    max-width: 100px;
    margin-bottom: -60px;

    transform: translateY(-50%);
  }

  &__stamp-anim {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 100px;
  }

  &__stamp {
    position: relative;
    top: 0;
    left: 0;
    max-width: 100px;

    // opacity: 0;
  }

  &__modal-toggle {
    cursor: pointer;
  }

  .separator {
    margin: 0 18px;
    opacity: 0.75;
  }
}
</style>
